<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/FixedProducts'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reFrJobDateStart"
                      name="reFrJobDateStart"
                      ref="reFrJobDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reFrJobDateEnd"
                      name="reFrJobDateEnd"
                      ref="reFrJobDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reFrBarcode'"
                    :name="'reFrBarcode'"
                    :select2-options="reFrBarcodeOptions"
                    multiple
                    v-model="reFrBarcode"
                    ref="reFrBarcodeSelect2"
                  ></select2> -->
                  <input
                    v-model="reFrBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reFrDepartmentMaterialCode'"
                    :name="'reFrDepartmentMaterialCode'"
                    :select2-options="reFrDepartmentMaterialCodeOptions"
                    v-model="reFrDepartmentMaterialCode"
                    ref="reFrDepartmentMaterialCodeSelect2"
                    multiple
                  ></select2> -->

                  <treeselect
                    v-model="reFrDepartmentMaterialCode"
                    :multiple="true"
                    :load-options="LoadreFrDepartmentMaterialCodeOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เลขที่เอกสาร:</label>
                  <textarea
                    v-model="reFrJobNumber"
                    type="text"
                    class="form-control"
                    rows="1"
                    placeholder="ค้นหาจาก เลขที่เอกสาร"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รายการอะไหล่:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reFrSparePartCode'"
                    :name="'reFrSparePartCode'"
                    :select2-options="reFrSparePartCodeOptions"
                    multiple
                    v-model="reFrSparePartCode"
                  ></select2> -->
                  <treeselect
                    v-model="reFrSparePartCode"
                    :multiple="true"
                    :options="reFrSparePartCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้ซ่อม:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reFrByUser'"
                    :name="'reFrByUser'"
                    :select2-options="reFrByUserOptions"
                    multiple
                    v-model="reFrByUser"
                  ></select2> -->
                  <treeselect
                    v-model="reFrByUser"
                    :multiple="true"
                    :options="reFrByUserOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>หมวดสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reFrProductGroup'"
                    :name="'reFrProductGroup'"
                    :select2-options="reFrProductGroupOptions"
                    multiple
                    v-model="reFrProductGroup"
                  ></select2> -->
                  <treeselect
                    v-model="reFrProductGroup"
                    :multiple="true"
                    :options="reFrProductGroupOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reFrProductType'"
                    :name="'reFrProductType'"
                    :select2-options="reFrProductTypeOptions"
                    multiple
                    v-model="reFrProductTypeOptions"
                  ></select2> -->
                  <treeselect
                    v-model="reFrProductType"
                    :multiple="true"
                    :options="reFrProductTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reFrMaterialCode'"
                    :name="'reFrMaterialCode'"
                    :select2-options="reFrMaterialCodeOptions"
                    multiple
                    v-model="reFrMaterialCode"
                  ></select2> -->
                  <treeselect
                    v-model="reFrMaterialCode"
                    :multiple="true"
                    :options="reFrMaterialCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3" v-if="this.$root.canShow(['BR_REPORT'])">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportFixedProducts"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="fixedProductTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="15">
                      ข้อมูล ณ วันที่ {{ reFrDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เลขที่เอกสาร</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <th class="all text-center">ผู้ซ่อม</th>
                    <th class="all text-center">หมวดสินค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all text-center">รายการอะไหล่</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">ราคา</th>
                  </tr>
                </thead>
                <tfoot v-if="isShowFooter">
                  <tr>
                    <th class="text-right" colspan="14">ราคารวม</th>
                    <th class="text-center">
                      {{ this.$options.filters.currency(TotalAmount, "฿") }}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reFrIsInitial: true,
      reFrDateReq: null,
      reFrJobDateStart: null,
      reFrJobDateEnd: null,
      reFrBarcode: null,
      reFrDepartmentMaterialCode: [],
      reFrJobNumber: null,
      reFrSparePartCode: [],
      reFrByUser: [],
      reFrProductGroup: [],
      reFrProductType: [],
      reFrMaterialCode: [],
      reJrJobRetrieve: [],
      TotalAmount: 0,
      isShowFooter: false,
      reFrBarcodeOptions: {
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reFrDepartmentMaterialCodeOptions: [],
      // reFrDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สินเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrSparePartCodeOptions: [],
      // reFrSparePartCodeOptions: {
      //   placeholder: "กรุณาเลือกรายการอะไหล่",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/ProductJob",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrByUserOptions: [],
      // reFrByUserOptions: {
      //   placeholder: "กรุณาเลือกผู้ซ่อม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ByUser",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrProductGroupOptions: [],
      // reFrProductGroupOptions: {
      //   placeholder: "กรุณาเลือกหมวดสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrProductTypeOptions: [],
      // reFrProductTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrMaterialCodeOptions: [],
      // reFrMaterialCodeOptions: {
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.reFrJobDateStart = null;
      self.reFrJobDateEnd = null;
      self.reFrBarcode = null;
      self.reFrDepartmentMaterialCode = [];
      self.reFrJobNumber = null;
      self.reFrSparePartCode = [];
      self.reFrByUser = [];
      self.reFrProductGroup = [];
      self.reFrProductType = [];
      self.reFrMaterialCode = [];

      $("#reFrJobDateStart")
        .val("")
        .trigger("change");

      $("#reFrJobDateEnd")
        .val("")
        .trigger("change");

      $("#reFrBarcode")
        .val("")
        .trigger("change");

      $("#reFrDepartmentMaterialCode")
        .val("")
        .trigger("change");

      $("#reFrSparePartCode")
        .val("")
        .trigger("change");

      $("#reFrByUser")
        .val("")
        .trigger("change");

      $("#reFrProductGroup")
        .val("")
        .trigger("change");

      $("#reFrProductType")
        .val("")
        .trigger("change");

      $("#reFrMaterialCode")
        .val("")
        .trigger("change");

      //this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      if (!self.reFrJobDateStart && self.reFrJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่เริ่มต้น", "warning");
        return false;
      } else if (self.reFrJobDateStart && !self.reFrJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่สิ้นสุด", "warning");
        return false;
      }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      let status = null;
      // if(self.reFrDepartmentMaterialCode !=null){
      //   status = $("#reFrDepartmentMaterialCode").text();
      //   console
      // }

      e.preventDefault();
      var table = $("#fixedProductTable").DataTable();
      table.draw();
    },
    exportFixedProducts: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportFixedProducts",
        responseType: "arraybuffer",
        data: {
          JobDateStart:
            self.reFrJobDateStart != null
              ? self.reFrJobDateStart.format("DD/MM/YYYY")
              : self.reFrJobDateStart,
          JobDateEnd:
            self.reFrJobDateEnd != null
              ? self.reFrJobDateEnd.format("DD/MM/YYYY")
              : self.reFrJobDateEnd,
          Barcode: self.reFrBarcode,
          DepartmentMaterialCode: self.reFrDepartmentMaterialCode,
          SparePartCode: self.reFrSparePartCode,
          JobNumber: self.reFrJobNumber,
          ByUser: self.reFrByUser,
          MaterialCode: self.reFrMaterialCode,
          ProductGroup: self.reFrProductGroup,
          ProductType: self.reFrProductType,
          IsInitial: self.reFrIsInitial,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreFrDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reFrDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reFrDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.reFrDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reFrDepartmentMaterialCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreFrSparePartCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/ProductJob", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reFrSparePartCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreFrByUserOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2ByUser", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reFrByUserOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreFrProductGroupOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reFrProductGroupOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreFrProductTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reFrProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreFrMaterialCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reFrMaterialCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadreFrSparePartCodeOptions();
    self.LoadreFrByUserOptions();
    self.LoadreFrProductGroupOptions();
    self.LoadreFrProductTypeOptions();
    self.LoadreFrMaterialCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reFrDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reFrJobDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });

    $(self.$refs.reFrJobDateStart).on("changeDate", function(e) {
      self.reFrJobDateStart = moment(e.date);
    });

    $(self.$refs.reFrJobDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });

    $(self.$refs.reFrJobDateEnd).on("changeDate", function(e) {
      self.reFrJobDateEnd = moment(e.date);
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#fixedProductTable");
    // begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/FixedProducts",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            self.isShowFooter = false;
            self.TotalAmount = 0;

            let jsonSearch = {
              JobDateStart:
                self.reFrJobDateStart != null
                  ? self.reFrJobDateStart.format("DD/MM/YYYY")
                  : self.reFrJobDateStart,
              JobDateEnd:
                self.reFrJobDateEnd != null
                  ? self.reFrJobDateEnd.format("DD/MM/YYYY")
                  : self.reFrJobDateEnd,
              Barcode: self.reFrBarcode,
              IsInitial: self.reFrIsInitial,
              DepartmentMaterialCode: self.reFrDepartmentMaterialCode,
              SparePartCode: self.reFrSparePartCode,
              JobNumber: self.reFrJobNumber,
              ByUser: self.reFrByUser,
              MaterialCode: self.reFrMaterialCode,
              ProductGroup: self.reFrProductGroup,
              ProductType: self.reFrProductType,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[2, "desc"]],
        columns: [
          {
            data: "jobDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "jobNumber", className: "text-center" },
          {
            data: "jobDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.jobDateString;
            },
          },
          { data: "monthString", className: "text-center" },
          { data: "year", className: "text-center" },
          { data: "displayName", className: "text-center" },
          { data: "productGroupName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "materialName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "departmentMaterialCode", className: "text-center" },
          { data: "sparePartName", className: "text-center" },
          {
            data: "quantity",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "pricing",
            className: "text-center",
            render: function(data, type, full, meta) {
              return self.$options.filters.currency(data, "฿");
            },
          },
        ],
        drawCallback: function(settings) {
          self.reFrIsInitial = false;
          self.reFrDateReq = moment().format("DD/MM/YYYY h:mm a");

          var allPage = table.DataTable().page.info().pages;
          var currentPage = table.DataTable().page.info().page + 1;

          if (allPage == currentPage) {
            self.isShowFooter = true;
            self.TotalAmount = settings.json.data[0].totalAmount;
          }
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/FixedProducts.vue